/* Live product search for the header search bar.
   Uses Shopify's predictive search endpoint (/search/suggest.json) and shows
   matching products as the visitor types. No dependencies. */
(function () {
  var form = document.querySelector('[data-search-form]');
  if (!form) return;

  var input = form.querySelector('input[name="q"]');
  var panel = form.querySelector('[data-search-panel]');
  var clearBtn = form.querySelector('[data-search-clear]');
  if (!input || !panel) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = form.getAttribute('data-currency') || '';
  var MIN_CHARS = 2;
  var LIMIT = 6;
  var timer = null;
  var controller = null;
  var cache = {};
  var items = [];
  var active = -1;
  var lastQuery = '';

  var priceFmt;
  try {
    priceFmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD', maximumFractionDigits: 0 });
  } catch (e) { priceFmt = null; }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return priceFmt ? priceFmt.format(n) : n.toFixed(0);
  }
  function priceLabel(p) {
    var lo = parseFloat(p.price_min != null ? p.price_min : p.price);
    var hi = parseFloat(p.price_max != null ? p.price_max : p.price);
    if (isNaN(lo)) return '';
    return (hi > lo ? 'From ' : '') + money(lo);
  }
  function cap(s) {
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }

  function open() {
    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }
  function close() {
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    active = -1;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function imgUrl(p) {
    var u = (p.featured_image && p.featured_image.url) || p.image || '';
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function setActive(i) {
    var nodes = panel.querySelectorAll('[role="option"]');
    if (!nodes.length) return;
    if (i < 0) i = nodes.length - 1;
    if (i >= nodes.length) i = 0;
    for (var k = 0; k < nodes.length; k++) nodes[k].classList.toggle('is-active', k === i);
    active = i;
    input.setAttribute('aria-activedescendant', nodes[i].id);
    nodes[i].scrollIntoView({ block: 'nearest' });
  }

  function viewAllUrl(q) {
    return form.getAttribute('action') + '?type=product&q=' + encodeURIComponent(q);
  }

  function render(q, products) {
    panel.textContent = '';
    items = products;
    active = -1;

    if (!products.length) {
      var empty = el('div', 'search-empty');
      empty.appendChild(el('strong', null, 'No plants found for “' + q + '”'));
      empty.appendChild(el('span', null, 'Check the spelling or try a shorter word, e.g. “mango” or “fig”.'));
      panel.appendChild(empty);
      open();
      return;
    }

    var list = el('ul', 'search-list');
    list.setAttribute('role', 'presentation');
    products.forEach(function (p, i) {
      var li = el('li');
      li.setAttribute('role', 'presentation');
      var a = el('a', 'search-item');
      a.href = p.url;
      a.id = 'tc-search-opt-' + i;
      a.setAttribute('role', 'option');

      var thumb = el('span', 'search-thumb');
      var src = imgUrl(p);
      if (src) {
        var im = document.createElement('img');
        im.src = src;
        im.alt = '';
        im.loading = 'lazy';
        im.width = 48;
        im.height = 48;
        thumb.appendChild(im);
      }
      var text = el('span', 'search-text');
      text.appendChild(el('span', 'search-title', p.title));
      var sub = cap(p.type || p.product_type || '');
      if (sub) text.appendChild(el('span', 'search-sub', sub));

      a.appendChild(thumb);
      a.appendChild(text);
      if (p.available === false) {
        a.appendChild(el('span', 'search-price search-soldout', 'Sold out'));
      } else {
        a.appendChild(el('span', 'search-price', priceLabel(p)));
      }
      a.addEventListener('mousemove', function () { setActive(i); });
      li.appendChild(a);
      list.appendChild(li);
    });
    panel.appendChild(list);

    var all = el('a', 'search-all');
    all.href = viewAllUrl(q);
    all.appendChild(el('span', null, 'See all results for “' + q + '”'));
    all.appendChild(el('span', null, '→'));
    panel.appendChild(all);
    open();
  }

  function renderLoading() {
    if (!panel.hidden && panel.querySelector('.search-list')) return;
    panel.textContent = '';
    panel.appendChild(el('div', 'search-loading', 'Searching…'));
    open();
  }

  function search(q) {
    if (cache[q]) { render(q, cache[q]); return; }
    if (controller && controller.abort) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    renderLoading();
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,vendor,tag,variants.title';
    fetch(url, { signal: controller ? controller.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
      .then(function (data) {
        if (input.value.trim() !== q) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        cache[q] = products;
        render(q, products);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        close();
      });
  }

  function onInput() {
    var q = input.value.trim();
    clearBtn.hidden = !input.value.length;
    clearTimeout(timer);
    if (q.length < MIN_CHARS) { close(); lastQuery = ''; return; }
    if (q === lastQuery && !panel.hidden) return;
    lastQuery = q;
    timer = setTimeout(function () { search(q); }, 180);
  }

  input.addEventListener('input', onInput);
  input.addEventListener('focus', function () {
    var q = input.value.trim();
    if (q.length >= MIN_CHARS && panel.children.length) open();
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (panel.hidden) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
    else if (e.key === 'Enter' && active > -1 && items[active]) {
      e.preventDefault();
      window.location.href = items[active].url;
    }
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    close();
    input.focus();
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) close();
  });

  clearBtn.hidden = !input.value.length;
})();
